(()=>{const $=(s,c=document)=>c.querySelector(s),$$=(s,c=document)=>[...c.querySelectorAll(s)];
function openDrawer(){document.body.classList.add('drawer-open')}function closeDrawer(){document.body.classList.remove('drawer-open')}
$$('[data-cart-open]').forEach(x=>x.addEventListener('click',e=>{e.preventDefault();openDrawer()}));$$('[data-drawer-close],.drawer-overlay').forEach(x=>x.addEventListener('click',closeDrawer));document.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawer()});
const root=$('[data-linked-variants]');if(root){const data=JSON.parse($('[data-variant-json]',root).textContent);const selects={style:null,gender:null,size:null};const groups={style:$('[data-option="style"]',root),gender:$('[data-option="gender"]',root),size:$('[data-option="size"]',root)};const add=$('[data-add]',root),id=$('[name="id"]',root),note=$('[data-variant-note]',root),price=$('[data-product-price]',root),image=$('[data-product-image]');
const prices=$$('[data-product-price]');const norm=s=>(s||'').toLowerCase();const keys=data.optionNames.map(norm);const idx=n=>keys.indexOf(n);const val=(v,n)=>v.options[idx(n)];
function values(name){return [...new Set(data.variants.filter(v=>!selects.style||name==='style'||val(v,'style')===selects.style).filter(v=>!selects.gender||name==='style'||name==='gender'||val(v,'gender')===selects.gender).map(v=>val(v,name)).filter(Boolean))]}
function render(name){const box=groups[name];if(!box)return;$$('button',box).forEach(b=>{b.hidden=!values(name).includes(b.dataset.value);b.classList.toggle('selected',selects[name]===b.dataset.value);b.setAttribute('aria-pressed',selects[name]===b.dataset.value)})}
function match(){return data.variants.find(v=>val(v,'style')===selects.style&&val(v,'gender')===selects.gender&&val(v,'size')===selects.size)}
function sync(){render('gender');render('size');const v=match();id.value=v?.id||'';add.disabled=!(v&&v.available);$$('[data-add-proxy]',root).forEach(b=>b.disabled=add.disabled);note.textContent=!selects.style?'Choose a style first':!selects.gender?'Choose Men\'s or Women\'s':!selects.size?'Choose an available US / UK size':v&&!v.available?'This combination is sold out':v?'Ready to add to bag':'This combination is unavailable';if(v){prices.forEach(p=>p.textContent=v.price);if(image&&v.image)image.src=v.image}}
$$('[data-option] button',root).forEach(b=>b.addEventListener('click',()=>{const name=b.closest('[data-option]').dataset.option;selects[name]=b.dataset.value;if(name==='style'){selects.gender=null;selects.size=null;const first=data.variants.find(v=>val(v,'style')===selects.style&&v.image);if(first&&image)image.src=first.image}else if(name==='gender')selects.size=null;sync()}));$$('[data-add-proxy]',root).forEach(b=>b.addEventListener('click',()=>$('#LinkedProductForm',root)?.requestSubmit()));sync();
$('[data-product-form],#LinkedProductForm',root)?.addEventListener('submit',async e=>{e.preventDefault();if(add.disabled)return;add.disabled=true;try{const fd=new FormData(e.currentTarget);const res=await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});if(!res.ok)throw Error();const cart=await fetch('/cart.js').then(r=>r.json()),box=$('.drawer-content');if(box)box.innerHTML=cart.items.map(x=>`<div class="cart-line"><img src="${x.image}" alt=""><div><h3>${x.product_title}</h3><p>${x.variant_title}</p><strong>${new Intl.NumberFormat(undefined,{style:'currency',currency:cart.currency}).format(x.final_line_price/100)}</strong></div></div>`).join('');$$('.cart-count').forEach(c=>c.textContent=cart.item_count);openDrawer()}catch{note.textContent='Could not add this item. Please try again.'}finally{add.disabled=false}})}
const highRoot=$('[data-high-variant-product]');if(highRoot){const query=new URLSearchParams(location.search),selected=(query.get('option_values')||'').split(',').filter(Boolean),groups=$$('.high-option-group',highRoot);groups.forEach((group,index)=>{group.hidden=false;group.classList.toggle('is-locked',index>selected.length);$$('input[data-option-value-id]',group).forEach(input=>{input.checked=selected[index]===input.dataset.optionValueId;input.nextElementSibling?.classList.toggle('selected',input.checked)})});$('.high-variant-picker',highRoot)?.addEventListener('change',e=>{const input=e.target.closest('input[data-option-value-id]');if(!input)return;const position=Number(input.dataset.optionPosition)-1,ids=selected.slice(0,position);ids[position]=input.dataset.optionValueId;const url=new URL(input.dataset.productUrl||highRoot.dataset.productUrl,location.origin);url.searchParams.set('option_values',ids.join(','));location.assign(url.toString())});const form=$('#HighVariantProductForm',highRoot),add=$('[data-high-add]',highRoot),note=$('[data-high-note]',highRoot);$$('[data-high-add-proxy]',highRoot).forEach(b=>b.addEventListener('click',()=>form?.requestSubmit()));form?.addEventListener('submit',async e=>{e.preventDefault();if(!add||add.disabled)return;add.disabled=true;try{const fd=new FormData(form),res=await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});if(!res.ok)throw Error();const cart=await fetch('/cart.js').then(r=>r.json()),box=$('.drawer-content');if(box)box.innerHTML=cart.items.map(x=>`<div class="cart-line"><img src="${x.image}" alt=""><div><h3>${x.product_title}</h3><p>${x.variant_title}</p><strong>${new Intl.NumberFormat(undefined,{style:'currency',currency:cart.currency}).format(x.final_line_price/100)}</strong></div></div>`).join('');openDrawer()}catch{if(note)note.textContent='Could not add this size. Please try again.'}finally{add.disabled=false}})}
$$('.quantity').forEach(q=>{const input=$('input',q),buttons=$$('button',q);buttons.forEach((b,i)=>b.addEventListener('click',()=>{if(input)input.value=Math.max(1,Number(input.value||1)+(i===0?-1:1))}))});
function saved(){return JSON.parse(localStorage.getItem('zevaro-saved')||'[]')}function bindWish(scope=document){$$('[data-wish]',scope).forEach(b=>b.addEventListener('click',()=>{const k=b.dataset.wish,a=saved(),exists=a.some(x=>x.key===k),n=exists?a.filter(x=>x.key!==k):[...a,{key:k,html:b.closest('.product-card').outerHTML}];localStorage.setItem('zevaro-saved',JSON.stringify(n));b.textContent=exists?'♡':'♥';const grid=$('[data-saved-grid]');if(grid)renderSaved(grid)}))}function renderSaved(grid){const a=saved();grid.innerHTML=a.length?a.map(x=>x.html).join(''):'<div class="card"><p>Tap the heart on any product to save it here.</p></div>';$$('[data-wish]',grid).forEach(b=>b.textContent='♥');bindWish(grid)}bindWish();const savedGrid=$('[data-saved-grid]');if(savedGrid)renderSaved(savedGrid);
$$('a[href$="/cart/checkout"]').forEach(a=>a.href='/checkout');
$$('.filters').forEach(bar=>$$('.filter-chip',bar).forEach(chip=>chip.addEventListener('click',()=>{const value=chip.textContent.trim().toLowerCase();$$('.filter-chip',bar).forEach(x=>x.classList.toggle('active',x===chip));$$('.live-grid .product-card').forEach(card=>card.parentElement.hidden=value!=='all'&&card.dataset.category!==value)})));
})();

/* ===== ZEVARO STYLE DRAG START ===== */

(() => {
  let slider = null;
  let pointerId = null;
  let startX = 0;
  let startY = 0;
  let startScrollLeft = 0;
  let isDragging = false;
  let blockNextClick = false;

  document.addEventListener(
    'pointerdown',
    function (event) {
      const currentSlider = event.target.closest('.styles-scroll');

      if (!currentSlider) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      slider = currentSlider;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = slider.scrollLeft;
      isDragging = false;
      blockNextClick = false;

      slider.classList.add('zevaro-drag-ready');

      if (slider.setPointerCapture) {
        slider.setPointerCapture(pointerId);
      }

      /* Stop the product link from starting browser drag */
      if (event.pointerType === 'mouse') {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (!slider || event.pointerId !== pointerId) return;

      const distanceX = event.clientX - startX;
      const distanceY = event.clientY - startY;

      if (
        !isDragging &&
        Math.abs(distanceX) > 3 &&
        Math.abs(distanceX) > Math.abs(distanceY)
      ) {
        isDragging = true;
        blockNextClick = true;
        slider.classList.add('zevaro-is-dragging');
      }

      if (!isDragging) return;

      event.preventDefault();
      slider.scrollLeft = startScrollLeft - distanceX;
    },
    { passive: false }
  );

  function stopDragging(event) {
    if (!slider) return;
    

    if (
      event.pointerId !== undefined &&
      pointerId !== null &&
      event.pointerId !== pointerId
    ) {
      return;
    }

    slider.classList.remove('zevaro-drag-ready');
    slider.classList.remove('zevaro-is-dragging');

    if (
      slider.hasPointerCapture &&
      pointerId !== null &&
      slider.hasPointerCapture(pointerId)
    ) {
      slider.releasePointerCapture(pointerId);
    }

    slider = null;
    pointerId = null;
    isDragging = false;

    window.setTimeout(function () {
      blockNextClick = false;
    }, 150);
  }

  document.addEventListener('pointerup', stopDragging);
  document.addEventListener('pointercancel', stopDragging);

  /* Prevent opening product page after horizontal dragging */
  document.addEventListener(
    'click',
    function (event) {
      if (!blockNextClick) return;
      if (!event.target.closest('.styles-scroll')) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  /* Prevent Chrome from dragging the whole product link */
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest('.styles-scroll')) {
      event.preventDefault();
    }
  });
})();

/* ===== ZEVARO STYLE DRAG END ===== */

/* ===== ZEVARO STYLE IMAGE SWITCH START ===== */

document.addEventListener('click', function (event) {
  const button = event.target.closest(
    '.style-chip[data-style-image]'
  );

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const card = button.closest('.product-card');
  const image = card
    ? card.querySelector('.product-media img')
    : null;

  const newImageUrl = button.dataset.styleImage;

  if (!card || !image || !newImageUrl) return;

  card.querySelectorAll('.style-chip').forEach(function (item) {
    item.classList.remove('is-active');
    item.setAttribute('aria-pressed', 'false');
  });

  button.classList.add('is-active');
  button.setAttribute('aria-pressed', 'true');

  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  image.src = newImageUrl;
  image.alt =
    (button.dataset.styleNumber || '') + ' product image';
});

(function () {
  if (window.ZevaroStyleControlsReady) return;
  window.ZevaroStyleControlsReady = true;

  var activeSlider = null;
  var activePointer = null;
  var startX = 0;
  var startY = 0;
  var startScroll = 0;
  var isDragging = false;
  var ignoreClickUntil = 0;

  document.addEventListener(
    'pointerdown',
    function (event) {
      var slider = event.target.closest('[data-style-slider]');

      if (!slider) return;
      event.stopPropagation();
      if (event.pointerType !== 'mouse') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      activeSlider = slider;
      activePointer = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScroll = slider.scrollLeft;
      isDragging = false;
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (!activeSlider) return;
      if (event.pointerId !== activePointer) return;

      var distanceX = event.clientX - startX;
      var distanceY = event.clientY - startY;

      if (
        !isDragging &&
        Math.abs(distanceX) > 5 &&
        Math.abs(distanceX) > Math.abs(distanceY)
      ) {
        isDragging = true;
        activeSlider.classList.add('is-dragging');
      }

      if (!isDragging) return;

      event.preventDefault();
      activeSlider.scrollLeft = startScroll - distanceX;
    },
    { passive: false }
  );

  function finishDragging(event) {
    if (!activeSlider) return;

    if (
      event.pointerId !== undefined &&
      event.pointerId !== activePointer
    ) {
      return;
    }

    if (isDragging) {
      ignoreClickUntil = Date.now() + 300;
    }

    activeSlider.classList.remove('is-dragging');
    activeSlider = null;
    activePointer = null;
    isDragging = false;
  }

  document.addEventListener('pointerup', finishDragging);
  document.addEventListener('pointercancel', finishDragging);

  document.addEventListener(
    'click',
    function (event) {
      var chip = event.target.closest('.style-chip');

      if (!chip) return;
      if (Date.now() < ignoreClickUntil) {
        event.preventDefault();
        return;
      }

      var card = chip.closest('.product-card');
      if (!card) return;

      var image = card.querySelector('.product-media img');
      var newImage = chip.getAttribute('data-style-image');

      if (!image || !newImage) return;

      event.preventDefault();
      event.stopPropagation();

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = newImage;
      image.alt =
        chip.getAttribute('data-style-number') + ' product image';

      card.querySelectorAll('.style-chip').forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      chip.classList.add('is-active');
      chip.setAttribute('aria-pressed', 'true');
    },
    true
  );
})();

/* ===== ZEVARO STYLE IMAGE SWITCH END ===== */

/* ===== ZEVARO SAVED HEART STATE START ===== */
(function () {
  function getSavedKeys() {
    try {
      var savedItems = JSON.parse(
        localStorage.getItem('zevaro-saved') || '[]'
      );

      return savedItems.map(function (item) {
        return String(item.key);
      });
    } catch (error) {
      return [];
    }
  }

  function updateSavedHearts() {
    var savedKeys = getSavedKeys();

    document.querySelectorAll('[data-wish]').forEach(function (button) {
      var isSaved = savedKeys.indexOf(String(button.dataset.wish)) !== -1;

      button.classList.toggle('is-saved', isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-wish]')) return;

    window.setTimeout(updateSavedHearts, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSavedHearts);
  } else {
    updateSavedHearts();
  }

  window.addEventListener('pageshow', updateSavedHearts);
})();
 /* ===== ZEVARO SAVED HEART STATE END ===== */
/* ===== ZEVARO BUY NOW START ===== */
document.addEventListener('click', function (event) {
  var buyButton = event.target.closest('[data-high-buy-now]');
  if (!buyButton) return;

  var root =
    buyButton.closest('[data-high-variant-product]') ||
    document.querySelector('[data-high-variant-product]');

  var form =
    buyButton.closest('form') ||
    (root ? root.querySelector('form') : null);

  var variantInput = form
    ? form.querySelector('input[name="id"]')
    : null;

  var variantsJson = root
    ? root.querySelector('[data-high-variants-json]')
    : null;

  if (!root || !form || !variantInput || !variantsJson) return;

  var variants;
  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (error) {
    return;
  }

  var selectedOptions = Array.from(
    root.querySelectorAll('.high-option-group')
  ).map(function (group) {
    var checked = group.querySelector(
      'input[type="radio"][data-option-position]:checked'
    );
    return checked ? checked.value : '';
  });

  var chosenVariant = variants.find(function (variant) {
    return (
      variant.available &&
      selectedOptions.length === variant.options.length &&
      selectedOptions.every(function (value, index) {
        return value && variant.options[index] === value;
      })
    );
  });

  if (!chosenVariant) {
    window.alert('Please choose an available Style, Gender and Size.');
    return;
  }

  variantInput.value = chosenVariant.id;
  buyButton.disabled = true;
  buyButton.textContent = 'OPENING CHECKOUT...';

  window.location.href =
    '/cart/' + encodeURIComponent(chosenVariant.id) + ':1?checkout';
});
/* ===== ZEVARO BUY NOW END ===== */
/* ===== ZEVARO CART QUANTITY START ===== */
(function () {
  const drawerContent = document.querySelector(
    '.drawer-content'
  );

  if (!drawerContent) return;

  let renderingCart = false;

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function formatCartMoney(cents, currency) {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      {
        style: 'currency',
        currency: currency || 'USD'
      }
    ).format(Number(cents) / 100);
  }

  function renderCart(cart) {
    renderingCart = true;

    if (!cart.items.length) {
      drawerContent.innerHTML = `
        <div class="drawer-empty">
          <h3>Your bag is empty</h3>
          <p>Choose a live item to begin.</p>
        </div>
      `;
    } else {
      drawerContent.innerHTML = cart.items
        .map(function (item) {
          return `
            <div
              class="cart-line"
              data-cart-line
              data-cart-key="${escapeHtml(item.key)}"
            >
              <img
                src="${escapeHtml(item.image)}"
                alt="${escapeHtml(item.product_title)}"
              >

              <div class="cart-line-information">
                <span class="live-tag">LIVE ITEM</span>

                <h3>
                  ${escapeHtml(item.product_title)}
                </h3>

                <p>
                  ${escapeHtml(item.variant_title)}
                </p>

                <strong data-cart-line-price>
                  ${formatCartMoney(
                    item.final_line_price,
                    cart.currency
                  )}
                </strong>

                <div class="cart-quantity">
                  <button
                    type="button"
                    data-cart-minus
                    data-cart-key="${escapeHtml(item.key)}"
                    aria-label="Decrease quantity"
                  >
                    −
                  </button>

                  <span data-cart-quantity>
                    ${item.quantity}
                  </span>

                  <button
                    type="button"
                    data-cart-plus
                    data-cart-key="${escapeHtml(item.key)}"
                    aria-label="Increase quantity"
                  >
                    +
                  </button>

                  <button
                    class="cart-remove"
                    type="button"
                    data-cart-remove
                    data-cart-key="${escapeHtml(item.key)}"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          `;
        })
        .join('');
    }

    document
      .querySelectorAll('.cart-count')
      .forEach(function (element) {
        element.textContent = cart.item_count;
      });

    window.setTimeout(function () {
      renderingCart = false;
    }, 0);
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    return response.json();
  }

  async function changeQuantity(key, quantity) {
    drawerContent.classList.add('is-loading');

    try {
      const response = await fetch(
        '/cart/change.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: Math.max(0, quantity)
          })
        }
      );

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      const cart = await response.json();
      renderCart(cart);
    } finally {
      drawerContent.classList.remove('is-loading');
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '[data-cart-minus], ' +
        '[data-cart-plus], ' +
        '[data-cart-remove]'
      );

      if (!button) return;

      const line = button.closest('[data-cart-line]');
      const quantityElement = line
        ? line.querySelector('[data-cart-quantity]')
        : null;

      const currentQuantity = quantityElement
        ? Number(quantityElement.textContent)
        : 1;

      const key = button.dataset.cartKey;

      if (!key) return;

      if (button.matches('[data-cart-plus]')) {
        changeQuantity(key, currentQuantity + 1);
      } else if (button.matches('[data-cart-minus]')) {
        changeQuantity(key, currentQuantity - 1);
      } else {
        changeQuantity(key, 0);
      }
    }
  );

  const observer = new MutationObserver(
    async function () {
      if (renderingCart) return;

      const hasCartLine =
        drawerContent.querySelector('.cart-line');

      const hasQuantity =
        drawerContent.querySelector('.cart-quantity');

      if (hasCartLine && !hasQuantity) {
        renderingCart = true;

        try {
          renderCart(await getCart());
        } catch (error) {
          renderingCart = false;
        }
      }
    }
  );

  observer.observe(drawerContent, {
    childList: true,
    subtree: true
  });
})();
 /* ===== ZEVARO CART QUANTITY END ===== */
/* ZEVARO：三级联动修复 */
(() => {
  const root = document.querySelector('[data-high-variant-product]');
  if (!root) return;

  const picker = root.querySelector('.high-variant-picker');
  const data = root.querySelector('[data-high-variants-json]');
  const form = root.querySelector('form');
  const idInput = root.querySelector('[data-high-variant-id]');
  const groups = [...root.querySelectorAll('.high-option-group')];

  if (!picker || !data || !form || !idInput || !groups.length) return;

  let variants = [];

  try {
    variants = JSON.parse(data.textContent);
  } catch (error) {
    return;
  }

  const selected = Array(groups.length).fill('');

  function matchesPrevious(variant, position) {
    for (let i = 0; i < position; i++) {
      if (selected[i] && variant.options[i] !== selected[i]) return false;
    }
    return true;
  }
function updatePicker() {
  groups.forEach((group, position) => {
    const unlocked = position === 0 || Boolean(selected[position - 1]);

    /* 三个栏目首次进入全部显示 */
    group.style.setProperty(
      'display',
      'block',
      'important'
    );

    /* 未完成上一步时，后续栏目不可选择 */
    group.classList.toggle('is-locked', !unlocked);

    group.querySelectorAll('input[type="radio"]').forEach((input) => {
      const canShow = variants.some((variant) =>
        matchesPrevious(variant, position) &&
        variant.options[position] === input.value
      );

      const choice = input.closest('.variant-choice');

      if (choice) {
        choice.style.setProperty(
          'display',
          canShow ? 'inline-flex' : 'none',
          'important'
        );
      }

      /* 未选上一步，不能点；选完后才按真实库存筛选 */
      input.disabled = !unlocked || !canShow;

      input.checked =
        unlocked &&
        canShow &&
        selected[position] === input.value;
    });
  });

  const chosenVariant = variants.find((variant) =>
    selected.every((value, index) =>
      value && variant.options[index] === value
    )
  );

  idInput.value = chosenVariant ? chosenVariant.id : '';

  root.querySelectorAll(
    'button[type="submit"], [data-high-add], [data-high-add-proxy], [data-high-buy-now]'
  ).forEach((button) => {
    button.disabled = !chosenVariant;
  });

  const price = root.querySelector('[data-high-price]');

  if (price && chosenVariant) {
    price.textContent = '$' + (chosenVariant.price / 100).toFixed(2);
  }
}
  picker.addEventListener('click', (event) => {
    const label = event.target.closest('label[for]');
    if (!label || !picker.contains(label)) return;

    const input = document.getElementById(label.htmlFor);
    if (!input || input.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  picker.addEventListener('change', (event) => {
    const input = event.target.closest(
      'input[type="radio"][data-option-position]'
    );

    if (!input) return;

    event.stopImmediatePropagation();

    const position = Number(input.dataset.optionPosition) - 1;

    selected[position] = input.value;

    for (let i = position + 1; i < selected.length; i++) {
      selected[i] = '';
    }

    updatePicker();
  }, true);

  updatePicker();
})();
/* ===== ZEVARO STYLE IMAGE SYNC START ===== */
(function () {
  function addImageWidth(url) {
    if (!url) return '';

    if (url.indexOf('//') === 0) {
      url = 'https:' + url;
    }

    if (url.indexOf('width=') === -1) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=1400';
    }

    return url;
  }

  function initStyleImageSync() {
    var rootData = [];

    document
      .querySelectorAll('[data-high-variant-product]')
      .forEach(function (root) {
        var dataNode = root.querySelector('[data-high-variants-json]');
        var mainImage = root.querySelector('.product-main-image img');

        if (!dataNode || !mainImage) return;

        var variants;

        try {
          variants = JSON.parse(dataNode.textContent);
        } catch (error) {
          return;
        }

        var styleImages = {};

        variants.forEach(function (variant) {
          var style = variant.options && variant.options[0];

          var imageUrl =
            (variant.featured_image && variant.featured_image.src) ||
            (variant.featured_media &&
              variant.featured_media.preview_image &&
              variant.featured_media.preview_image.src);

          if (style && imageUrl && !styleImages[style]) {
            styleImages[style] = addImageWidth(imageUrl);
          }
        });

        rootData.push({
          root: root,
          mainImage: mainImage,
          styleImages: styleImages
        });

        function preloadImages() {
          Object.keys(styleImages).forEach(function (style) {
            var preload = new Image();
            preload.src = styleImages[style];
          });
        }

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preloadImages);
        } else {
          window.setTimeout(preloadImages, 300);
        }
      });

    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;

        if (
          !input ||
          input.type !== 'radio' ||
          input.getAttribute('data-option-position') !== '1'
        ) {
          return;
        }

        var item = rootData.find(function (entry) {
          return entry.root.contains(input);
        });

        if (!item) return;

        var imageUrl = item.styleImages[input.value];

        if (!imageUrl || item.mainImage.src === imageUrl) return;

        item.mainImage.removeAttribute('srcset');
        item.mainImage.removeAttribute('sizes');
        item.mainImage.src = imageUrl;
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStyleImageSync);
  } else {
    initStyleImageSync();
  }
})();
/* ===== ZEVARO STYLE IMAGE SYNC END ===== */